import brand from "assets/images/logo.png";
import axios from "axios";
import dayjs from "dayjs";
import QRCode from "qrcode";
import { API_IMPRESION } from "services/config";
import { valorAPesos } from "utils/formatters";

const getPrintApiKey = () =>
  process.env.REACT_APP_APIKEY_IMPRESION ||
  process.env.REACT_APP_API_KEY_IMPRESION ||
  process.env.REACT_APP_IMPRESION_API_KEY ||
  "";

const getPrintAuthHeader = () => {
  const apiKey = String(getPrintApiKey() || "").trim();
  if (!apiKey) return "";
  return apiKey.toLowerCase().startsWith("bearer ") ? apiKey : `Bearer ${apiKey}`;
};

const getPrintHeaders = () => {
  const authorization = getPrintAuthHeader();
  return {
    "Content-Type": "application/json",
    ...(authorization ? { Authorization: authorization } : {}),
  };
};

const formatFactura = {
  A: "Factura A:",
  B: "Factura B:",
  V: "",
  "Nota de crédito A": "Nota de crédito A:",
  "Nota de crédito B": "Nota de crédito B:",
  "Nota de crédito V": "",
};
const precioAmostrar = (precio, tipoFactura) => {
  return tipoFactura == "A" || tipoFactura == "Nota de crédito A" ? precio / 1.21 : precio;
};

const renderFacturaComponent = (factura, empresa, qrCodeURL) => {
  return `<div style="margin-top: -5px; margin-bottom: 5px;">
      
      <div
        style="
          border-bottom: 1px solid black;
        "
      >
      <h3
        style="
          text-align: left;
          font-weight: bold;
          margin-bottom: 10px;
        "
      >Pedido N° ${factura.nroPedido}</h3>
      <h4
        style="
          text-align: left;
          font-weight: bold;
          margin-bottom: 5px;
        "
      >${empresa.nombre}</h4>

      <p
        style="
          text-align: left;
          margin: 0;
          margin-bottom: 5px;
              font-size: 0.7rem;
        "
      >Cuit: ${30718861981}</p>
      </div>
      <div
        style="padding: 3px 0px; border-bottom: 1px solid black;"
      >
        <p
          style="
            font-weight: bold;
            margin: 0;
              font-size: 1rem;
          "
        >Cliente: ${factura.cliente
      ? factura.cliente
      : "CONSUMIDOR FINAL"
    }</p>
        ${factura.nro_doc !== "11111111"
      ? `<p
        style="
          margin: 0;
              font-size: 0.7rem;
        "
      >Cuit/Doc N°: ${factura.nro_doc || "0"}</p>`
      : ""
    }
      </div>
      <div
        style="padding: 3px 0px"
      >
      ${factura?.tipoFactura ? `<p style=" font-weight: bold; margin: 0; font-size: 0.7rem;">${formatFactura[factura.tipoFactura] || "B"}</p>` : ""}
        ${factura.nroAnulado ? `<p style="margin: 0; font-size: 0.7rem;">Anulada: ${factura.nroAnulado}</p>` : ""}
        ${factura.fechaFactura ? `<p style="margin: 0; font-size: 0.7rem;">Fecha: ${factura.fechaFactura}"</p>` : ""}
      </div>
      <div
        style="padding: 3px 0px; border-bottom: 1px solid black;"
      >
      <div
       style="display: grid; grid-template-columns: 1fr 2fr 2fr; grid-gap: 3px; border-bottom: 1px solid black;"
      >
        <p
          style="
            font-weight: bold;
            margin: 0;
            text-align: center;
              font-size: 0.7rem;
          "
        >Cant.</p>
        <p
          style="
            font-weight: bold;
            margin: 0;
              font-size: 0.7rem;
          "
        >Descripción</p>
        <p
          style="
            font-weight: bold;
            margin: 0;
            text-align: right;
              font-size: 0.7rem;
          "
        >Importe</p>
        </div>
          ${factura.pedido?.detalles
      ?.map((detalle) => {
        return `<div
          style="display: grid; grid-template-columns: 1fr 2fr 2fr; grid-gap: 3px; padding: 3px 0px;"
          >
            <p
              style="
                text-align: center;
                margin: 0;
              font-size: 0.7rem;
              "
            >${detalle.cantidad}</p>
            <p
              style="
                margin: 0;
              font-size: 0.7rem;
              "
            >${detalle.producto.nombre}</p>
            <p
              style="
                text-align: right;
                margin: 0;
              font-size: 0.7rem;
              "
            >${valorAPesos(
          precioAmostrar(detalle.precio, factura.tipoFactura) * detalle.cantidad
        )}</p>
            </div>`;
      })
      .join("")}
      </div>
      ${factura.descuento
      ? `<div
        style="display: grid; grid-template-columns: 2fr 1fr ; margin:0; padding:0;">
          <p
            style="
              margin: 0;
              text-align: right;
              font-size: 0.7rem;
            "
          >Descuento:</p>
          <p
            style="
              font-weight: bold;
              margin: 0;
              text-align: right;
              font-size: 0.7rem;
            "
          >${valorAPesos(precioAmostrar(factura.descuento, factura.tipoFactura))}</p>
          </div>
            `
      : ""
    }
       ${factura.recargo
      ? `<div
        style="display: grid; grid-template-columns: 2fr 1fr ; margin:0; padding:0;">
          <p
            style="
              margin: 0;
              text-align: right;
              font-size: 0.7rem;
            "
          >Recargo:</p>
          <p
            style="
              font-weight: bold;
              margin: 0;
              text-align: right;
              font-size: 0.7rem;
            "
          >${valorAPesos(precioAmostrar(factura.recargo, factura.tipoFactura))}</p>
          </div>
            `
      : ""
    }
      <div
        style="padding: 3px 0px;"
      >
      ${factura.tipoFactura == "A" || factura.tipoFactura == "Nota de crédito A"
      ? `<div
        style="display: grid; grid-template-columns: 2fr 1fr ; margin:0; padding:0;">
          <p
            style="
              margin: 0;
              text-align: right;
              font-size: 0.7rem;
            "
          >Subtotal:</p>
          <p
            style="
              font-weight: bold;
              margin: 0;
              text-align: right;
              font-size: 0.7rem;
            "
          >${valorAPesos(factura.subtotal21)}</p>
          </div>
            `
      : ""
    }
      ${factura.tipoFactura == "A" || factura.tipoFactura == "Nota de crédito A"
      ? `<div
        style="display: grid; grid-template-columns: 2fr 1fr ; margin:0; padding:0;">
          <p
            style="
              margin: 0;
              text-align: right;
              font-size: 0.7rem;
            "
          >IVA (21,00%):</p>
          <p
            style="
              font-weight: bold;
              margin: 0;
              text-align: right;
              font-size: 0.7rem;
            "
          >${valorAPesos(factura.imp_iva21)}</p>
          </div>
            `
      : ""
    }
      <div
        style="display: grid; grid-template-columns: 2fr 1fr; margin:0; padding:0;">
          <p
            style="
              margin: 0;
              text-align: right;
              font-size: 0.7rem;
            "
          >Total:</p>
          <p
            style="
              font-weight: bold;
              margin: 0;
              text-align: right;
              font-size: 0.7rem;
            "
          >${valorAPesos(factura.total)}</p>
          </div>
      </div>
      ${factura.CAE ? `<p
              style="margin: 0;
              font-size: 0.7rem;"
              
            >
        Régimen de Transparencia Fiscal al Consumidor (Ley 27.743)
        </p>
      <p
              style="margin: 0;
              font-size: 0.7rem;"
              
            >
        IVA Contenido: ${parseFloat(factura.total - factura.total / 1.21).toFixed(2)}
        </p>` : ""}
        ${factura.CAE
      ? `<p
              style="margin: 0;
              font-size: 0.7rem;"
              
            >
        Cae: ${factura.CAE}
        </p>
        <p
          style="margin: 0;
          font-size: 0.7rem;"
              
        >
        Vto Cae: ${factura.CAEFchVto}
        </p>`
      : ""
    }
      ${qrCodeURL
      ? `
        <div style="text-align: center;">
        <img id="qrcode" src="${qrCodeURL}" alt="QR Code" style="width: 150px; height: 150px;" />
      </div>
      `
      : ""
    }
    </div>`;
};

export const printFactura = async (factura, empresa) => {
  const qrCodeURL = factura.url ? await QRCode.toDataURL(factura.url) : null;
  var mywindow = window.open("", "PRINT", "width=300");

  mywindow.document.write("<html><head>");
  mywindow.document.write("</head><body >");
  mywindow.document.write(
    `
    ${renderFacturaComponent(factura, empresa, qrCodeURL)}
    `
  );
  mywindow.document.write("</body></html>");

  mywindow.document.close();
  mywindow.focus();

  const img = mywindow.document.getElementById("qrcode");
  if (img) {
    img.onload = function () {
      mywindow.print();
      mywindow.close();
    };
  } else {
    mywindow.print();
    mywindow.close();
  }

  return true;
};

export const printComanda = async (comanda, seccion, nota, mesa, mozo, cliente) => {
  const printName = typeof seccion === "string" ? seccion : seccion?.printName;
  const seccionHabilitada =
    typeof seccion === "object" ? seccion?.habilitado !== false : true;
  if (!printName || !seccionHabilitada) return null;

  const payload = {
    seccion: printName,
    printerName: printName,
    totalItems: comanda.reduce((acc, detalle) => acc + detalle.cantidad, 0),
    fecha: dayjs().format("DD/MM/YYYY"),
    hora: dayjs().format("HH:mm"),
    nroComanda: comanda[0]?.nroComanda,
    nota,
    mesa,
    mozo,
    cliente,
    detalles: comanda.map((detalle) => {
      return {
        cantidad: detalle.cantidad,
        producto: detalle.producto.nombre,
        observaciones: detalle?.observaciones || detalle?.comentario || "",
      };
    }),
  };

  const respuesta = await axios
    .post(
      // process.env.NODE_ENV === "production" ? `${API_IMPRESION}/printComanda` : `http://localhost:3000/printComanda`,
      `${API_IMPRESION}/printComanda`,
      JSON.stringify(payload),
      {
        headers: getPrintHeaders(),
      }
    )
    .catch((error) => {
      console.error(error);
    });
  return respuesta;
};

export const getPrintersStatus = async (printers = []) => {
  const printersEndpoint =
    process.env.NODE_ENV === "production"
      ? `${API_IMPRESION}/printers`
      : "http://localhost:3000/printers";

  const respuesta = await axios
    .get(
      printersEndpoint,
      {
        headers: getPrintHeaders(),
      }
    )
    .catch((error) => {
      console.error(error);
    });

  return respuesta;
};

export const printTicket = async (data, detalles, printerName = "Caja") => {
  const respuesta = await axios
    .post(
      process.env.NODE_ENV === "production" ? `${API_IMPRESION}/printFactura` : `http://localhost:3001/printFactura`,
      JSON.stringify({
        ...data,
        printerName,
        totalItems: detalles.reduce((acc, detalle) => acc + detalle.cantidad, 0),
        fecha: dayjs().format("DD/MM/YYYY HH:mm"),
        detalles: detalles.map((detalle) => {
          return {
            cantidad: detalle.cantidad,
            producto: detalle.producto.nombre,
            precio: detalle.precio,
          };
        }),
      }),
      {
        headers: getPrintHeaders(),
      }
    )
    .catch((error) => {
      console.error(error);
    });
  return respuesta;
};


export const printTicketTotem = async (data, detalles, printerName = "Totem") => {
  const respuesta = await axios
    .post(
      process.env.NODE_ENV === "production" ? `${API_IMPRESION}/printTotem` : `http://localhost:3001/printTotem`,
      JSON.stringify({
        fecha: dayjs().format("DD/MM/YYYY HH:mm:ss"),
        idPedido: data.idPedido,
        nroDocumento: data.nroDocumento,
        printerName,
        total: data.total,
        totalItems: detalles.reduce((acc, detalle) => acc + Number(detalle.cantidad), 0),
        descuento: data.descuento || 0,
        recargo: data.recargo || 0,
        detalles: detalles.map((detalle) => {
          return {
            producto: detalle.producto.nombre,
            cantidad: Number(detalle.cantidad),
            precio: Number(detalle.precio),
          };
        }),
      }),
      {
        headers: getPrintHeaders(),
      }
    )
    .catch((error) => {
      console.error(error);
    });
  return respuesta;
};
